@let section = sectionService.section();
@if (section && sectionService.visible()) {
  <div
    class="flex !w-full flex-col rounded-2xl bg-white"
    #ref
    style="scroll-margin-top: 108px"
  >
    <div
      [pTooltip]="section.customization.description"
      class="flex flex-row items-center justify-between gap-2 px-5 pb-4 pt-3"
    >
      <div class="flex flex-col gap-1">
        <div class="text-lg font-bold">{{ section.customization.title }}</div>
        <div class="text-sm">{{ section.customization.subTitle }}</div>
      </div>
      <div class="flex flex-col items-center gap-1">
        <div class="w-16 text-end text-lg font-bold">
          {{ section.customization.points }} pt
        </div>
      </div>
    </div>

    <div class="mx-4 flex flex-1 border-t-2 border-[#CAC4D0] opacity-50"></div>
    <div class="flex w-full flex-col">
      @for (subsection of section.children; track $index; let i = $index) {
        <lib-compiling-sub-section [uniqueId]="subsection" />
      }
    </div>
  </div>
}
